// extracted by mini-css-extract-plugin
export default {"wrapper":"fileupload_wrapper__FnbYv","wrapper__btn":"fileupload_wrapper__btn__RrEoV","wrapper__fileName":"fileupload_wrapper__fileName__KQTDp"};